(function(){
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var body = document.body;
  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function store(fn, fallback){
    try { return fn(); } catch(e){ return fallback; }
  }

  function closestTo(e, selector){
    var t = e.target;
    if(t && t.nodeType === 3) t = t.parentElement;
    return t && t.closest ? t.closest(selector) : null;
  }

  function formatMoney(cents, format){
    format = format || '₹{{amount}}';
    function fmt(n, decimals, thousands, dec){
      var parts = (n / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(dec);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, key){
      switch(key){
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- toast ---------- */
  var toastEl = document.querySelector('[data-toast]');
  var toastTimer;
  function toast(message, linkText, href){
    if(!toastEl) return;
    toastEl.textContent = message;
    if(linkText && href){
      var a = document.createElement('a');
      a.href = href;
      a.textContent = linkText;
      toastEl.appendChild(a);
    }
    toastEl.hidden = false;
    toastEl.classList.remove('is-visible');
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){
      toastEl.classList.remove('is-visible');
      setTimeout(function(){ toastEl.hidden = true; }, 200);
    }, 2800);
  }

  /* ---------- product cards fetched by handle (wishlist, recently viewed) ---------- */
  // resolves to [{card}|{gone:true}|{}] in the same order as the handles
  function fetchCards(handles){
    var results = new Array(handles.length);
    var next = 0;
    function worker(){
      if(next >= handles.length) return Promise.resolve();
      var i = next++;
      return fetch(root + 'products/' + encodeURIComponent(handles[i]) + '?view=card', { headers: { 'Accept': 'text/html' } })
        .then(function(res){
          if(res.status === 404) return { gone: true };
          if(!res.ok) return {};
          return res.text().then(function(html){
            var tpl = document.createElement('template');
            tpl.innerHTML = html.trim();
            var card = Array.prototype.find.call(tpl.content.children, function(el){ return el.matches('.card'); });
            return { card: card || null };
          });
        })
        .catch(function(){ return {}; })
        .then(function(r){ results[i] = r; return worker(); });
    }
    var workers = [];
    for(var w = 0; w < Math.min(6, handles.length); w++) workers.push(worker());
    return Promise.all(workers).then(function(){ return results; });
  }

  /* ---------- bag count badges ---------- */
  function setCartCount(n){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = !n;
    });
  }
  function refreshCartCount(){
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){ setCartCount(cart.item_count); return cart; })
      .catch(function(){});
  }

  /* ---------- wishlist ---------- */
  var WL_ON = body.getAttribute('data-wishlist') === 'on';
  var WL_KEY = 'bh:wishlist';
  var WL_MAX = 60;
  var wishlistUrl = body.getAttribute('data-wishlist-url') || (root + 'search?view=wishlist');

  function wlRead(){
    var list = store(function(){ return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); }, []);
    if(!Array.isArray(list)) return [];
    return list.filter(function(h, i){ return typeof h === 'string' && h && list.indexOf(h) === i; });
  }

  function wlWrite(list){
    store(function(){ localStorage.setItem(WL_KEY, JSON.stringify(list.slice(0, WL_MAX))); });
    wlSync();
  }

  function wlSync(){
    var list = wlRead();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn){
      var saved = list.indexOf(btn.getAttribute('data-handle')) !== -1;
      var title = btn.getAttribute('data-title') || 'item';
      btn.setAttribute('aria-pressed', String(saved));
      btn.setAttribute('aria-label', (saved ? 'Remove ' : 'Save ') + title + (saved ? ' from wishlist' : ' to wishlist'));
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el){
      el.textContent = list.length > 99 ? '99+' : String(list.length);
      el.hidden = list.length === 0;
    });
  }

  if(WL_ON){
    wlSync();

    document.addEventListener('click', function(e){
      var btn = closestTo(e, '[data-wishlist-toggle]');
      if(!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-handle');
      var list = wlRead();
      var i = list.indexOf(handle);
      var removed = i !== -1;
      if(removed){
        list.splice(i, 1);
      } else {
        list.unshift(handle);
        if(list.length > WL_MAX) list.length = WL_MAX;
      }
      wlWrite(list);
      btn.classList.remove('is-popping');
      void btn.offsetWidth;
      btn.classList.add('is-popping');

      if(page && !page.shared && removed){
        var card = btn.closest('.card');
        if(card) card.remove();
        page.updateSummary(wlRead().length);
        if(!page.grid.querySelector('.card')) page.render();
      }
      toast(removed ? 'Removed from wishlist' : 'Saved to wishlist', removed || page ? null : 'View', wishlistUrl);
    });

    // keep hearts and counts in step with other open tabs
    window.addEventListener('storage', function(e){
      if(e.key !== WL_KEY) return;
      wlSync();
      if(page && !page.shared) page.render();
    });

    // back/forward cache restores stale hearts
    window.addEventListener('pageshow', function(e){ if(e.persisted) wlSync(); });
  }

  /* ---------- wishlist page ---------- */
  var page = null;
  var grid = document.querySelector('[data-wishlist-grid]');
  if(grid && WL_ON){
    var params = new URLSearchParams(location.search);
    var sharedParam = params.get('items');
    var summary = document.querySelector('[data-wishlist-summary]');
    var empty = document.querySelector('[data-wishlist-empty]');
    var toolbar = document.querySelector('[data-wishlist-toolbar]');
    var sharedBanner = document.querySelector('[data-wishlist-shared]');
    var renderToken = 0;

    var sharedList = sharedParam ? sharedParam.split(',').filter(function(h, i, a){ return h && a.indexOf(h) === i; }).slice(0, WL_MAX) : null;

    page = {
      grid: grid,
      shared: !!(sharedList && sharedList.length),
      updateSummary: function(n){
        summary.textContent = n === 0 ? '' : n + (n === 1 ? ' saved item' : ' saved items');
      },
      render: function(){
        var token = ++renderToken;
        var list = page.shared ? sharedList : wlRead();
        sharedBanner.hidden = !page.shared;
        if(!list.length){
          grid.innerHTML = '';
          grid.setAttribute('aria-busy', 'false');
          empty.hidden = false;
          toolbar.hidden = true;
          page.updateSummary(0);
          return;
        }
        empty.hidden = true;
        grid.setAttribute('aria-busy', 'true');

        fetchCards(list).then(function(results){
          if(token !== renderToken) return;
          // forget products that were deleted or unpublished
          if(!page.shared){
            var gone = list.filter(function(_, i){ return results[i] && results[i].gone; });
            if(gone.length) store(function(){
              localStorage.setItem(WL_KEY, JSON.stringify(wlRead().filter(function(h){ return gone.indexOf(h) === -1; })));
            });
          }
          grid.innerHTML = '';
          // most-saved first (data-saves comes from the product's wishlist_count metafield);
          // ties keep the order they were saved in
          var cards = [];
          results.forEach(function(r, i){
            if(!r || !r.card) return;
            cards.push({ card: r.card, i: i, saves: parseInt(r.card.getAttribute('data-saves'), 10) || 0 });
          });
          cards.sort(function(a, b){ return b.saves - a.saves || a.i - b.i; });
          cards.forEach(function(c){ grid.appendChild(c.card); });
          var count = grid.querySelectorAll('.card').length;
          grid.setAttribute('aria-busy', 'false');
          empty.hidden = count > 0;
          toolbar.hidden = page.shared || count === 0;
          page.updateSummary(count);
          wlSync();
        });
      }
    };

    page.render();

    document.addEventListener('click', function(e){
      if(closestTo(e, '[data-wishlist-clear]')){
        if(!confirm('Remove all saved items?')) return;
        wlWrite([]);
        page.render();
      }

      if(closestTo(e, '[data-wishlist-save-all]')){
        var merged = wlRead();
        sharedList.forEach(function(h){ if(merged.indexOf(h) === -1) merged.push(h); });
        wlWrite(merged);
        toast('Saved to your wishlist');
        var clean = new URL(location.href);
        clean.searchParams.delete('items');
        history.replaceState(null, '', clean);
        page.shared = false;
        page.render();
      }

      if(closestTo(e, '[data-wishlist-share]')){
        var url = new URL(wishlistUrl, location.origin);
        url.searchParams.set('items', wlRead().join(','));
        var link = url.toString();
        if(navigator.share){
          navigator.share({ title: document.title, url: link }).catch(function(){});
        } else if(navigator.clipboard && window.isSecureContext){
          navigator.clipboard.writeText(link).then(function(){ toast('Link copied'); }, function(){ prompt('Copy this link', link); });
        } else {
          prompt('Copy this link', link);
        }
      }
    });
  } else if(grid){
    grid.innerHTML = '';
    grid.setAttribute('aria-busy', 'false');
    var off = document.querySelector('[data-wishlist-empty]');
    if(off) off.hidden = false;
  }

  /* ---------- product gallery: swipe on touch, arrows/thumbs/keys on desktop ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function(g){
    var sc = g.querySelector('[data-media-scroller]');
    var slides = sc.querySelectorAll('img');
    var thumbs = g.querySelectorAll('[data-gallery-thumb]');
    var prev = g.querySelector('[data-gallery-prev]');
    var next = g.querySelector('[data-gallery-next]');
    if(slides.length < 2) return;

    function current(){ return Math.round(sc.scrollLeft / Math.max(1, sc.clientWidth)); }
    function go(i){
      i = Math.max(0, Math.min(slides.length - 1, i));
      // images may be wrapped in .pdp-cell (desktop grid); measure the wrapper so scrolling still lands on the image
      var target = slides[i].closest('.pdp-cell') || slides[i];
      sc.scrollTo({ left: target.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function mark(){
      var i = current();
      thumbs.forEach(function(t, n){
        if(n === i){
          t.setAttribute('aria-current', 'true');
          t.parentNode.scrollTo({ left: t.offsetLeft - t.parentNode.clientWidth / 2 + t.clientWidth / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
        } else {
          t.removeAttribute('aria-current');
        }
      });
      if(prev) prev.disabled = i === 0;
      if(next) next.disabled = i === slides.length - 1;
    }

    var ticking = false;
    sc.addEventListener('scroll', function(){
      if(ticking) return;
      ticking = true;
      requestAnimationFrame(function(){ ticking = false; mark(); });
    }, { passive: true });
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ go(+t.getAttribute('data-gallery-thumb')); }); });
    if(prev) prev.addEventListener('click', function(){ go(current() - 1); });
    if(next) next.addEventListener('click', function(){ go(current() + 1); });
    sc.addEventListener('keydown', function(e){
      if(e.key === 'ArrowLeft'){ e.preventDefault(); go(current() - 1); }
      if(e.key === 'ArrowRight'){ e.preventDefault(); go(current() + 1); }
    });
    window.addEventListener('resize', function(){ go(current()); });

    g.goToMedia = function(id){
      slides.forEach(function(s, i){ if(s.getAttribute('data-media-id') === String(id)) go(i); });
    };
    mark();
  });

  /* ---------- product page: variant selection ---------- */
  var pdp = document.querySelector('[data-product-page]');
  if(pdp){
    var data = JSON.parse(pdp.querySelector('[data-product-json]').textContent);
    var form = pdp.querySelector('[data-product-form]');
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-button]');
    var errorEl = form.querySelector('[data-form-error]');
    var radios = form.querySelectorAll('input[data-option-index]');
    var gallery = pdp.querySelector('[data-gallery]');

    function selected(){
      var opts = [];
      radios.forEach(function(r){ if(r.checked) opts[+r.getAttribute('data-option-index')] = r.value; });
      return opts;
    }

    function matches(v, opts, skip){
      return opts.every(function(val, i){ return i === skip || val === undefined || v.options[i] === val; });
    }

    function currentVariant(){
      var id = +idInput.value;
      return data.variants.find(function(v){ return v.id === id; }) || data.variants[0];
    }
    function renderPrice(variant){
      if(!variant) return;
      pdp.querySelector('[data-price-now]').textContent = formatMoney(variant.price, data.moneyFormat);
      var was = pdp.querySelector('[data-price-was]');
      var save = pdp.querySelector('[data-save]');
      var discounted = variant.compare_at_price > variant.price;
      was.hidden = save.hidden = !discounted;
      if(discounted){
        was.textContent = formatMoney(variant.compare_at_price, data.moneyFormat);
        save.textContent = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '% off';
      }
      if(variant.available && !addBtn.disabled) addBtn.textContent = 'Add to bag';
    }
    // SKU + barcode under the title and in the details panel follow the chosen variant
    function renderCodes(variant){
      ['sku', 'barcode'].forEach(function(key){
        var value = variant[key] || '';
        pdp.parentNode.querySelectorAll('[data-code-wrap="' + key + '"]').forEach(function(w){ w.hidden = !value; });
        document.querySelectorAll(key === 'sku' ? '[data-variant-sku],[data-variant-sku-inline]' : '[data-variant-barcode]').forEach(function(el){ el.textContent = value; });
      });
    }

    // WhatsApp order message carries the chosen size, SKU and price
    var waBtn = pdp.querySelector('[data-pdp-wa]');
    function renderWhatsApp(variant){
      if(!waBtn || !variant) return;
      var lines = ['Hi ' + waBtn.getAttribute('data-shop-name') + ', I want to order this:', pdp.querySelector('h1').textContent.trim()];
      if(variant.title && variant.title !== 'Default Title') lines.push(waBtn.getAttribute('data-option-name') + ': ' + variant.title);
      if(variant.sku) lines.push('SKU: ' + variant.sku);
      var qtyInput = form.querySelector('[data-quantity]');
      var qty = qtyInput ? Math.max(1, +qtyInput.value || 1) : 1;
      if(qty > 1) lines.push('Quantity: ' + qty);
      lines.push('Price: ' + formatMoney(variant.price, data.moneyFormat));
      lines.push(waBtn.getAttribute('data-product-url') + '?variant=' + variant.id);
      waBtn.href = 'https://wa.me/' + waBtn.getAttribute('data-wa-number') + '?text=' + encodeURIComponent(lines.join('\n'));
    }
    if(waBtn){
      waBtn.addEventListener('pointerdown', function(){ renderWhatsApp(currentVariant()); });
      waBtn.addEventListener('focus', function(){ renderWhatsApp(currentVariant()); });
    }

    // quantity + can't go past the stock on hand (when Shopify tracks it and overselling is off)
    var qtyEl = form.querySelector('[data-quantity]');
    function applyStock(variant){
      if(!qtyEl || !variant) return;
      var cap = (variant.stock !== null && variant.policy === 'deny') ? Math.max(1, variant.stock) : 20;
      qtyEl.max = Math.min(20, cap);
      if(+qtyEl.value > +qtyEl.max) qtyEl.value = qtyEl.max;
      var st = qtyEl.closest('[data-stepper]');
      if(st) syncStepper(st);
    }
    applyStock(currentVariant());

    function update(fromUser){
      var opts = selected();
      var variant = data.variants.find(function(v){ return matches(v, opts, -1); });

      // grey out values that have no available variant with the other current choices
      radios.forEach(function(r){
        var i = +r.getAttribute('data-option-index');
        var ok = data.variants.some(function(v){ return v.available && v.options[i] === r.value && matches(v, opts, i); });
        r.parentNode.classList.toggle('sold', !ok);
      });

      if(!variant){
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Add to bag' : 'Sold out';

      renderPrice(variant);

      var stock = pdp.querySelector('[data-stock-note]');
      stock.textContent = (variant.stock > 0 && variant.stock <= 10) ? 'Only ' + variant.stock + ' left · ' : '';
      renderCodes(variant);
      applyStock(variant);
      renderWhatsApp(variant);

      // also on load, so a ?variant= link (e.g. a size chip) opens on that variant's photo
      if((fromUser || /[?&]variant=/.test(location.search)) && variant.media_id && gallery && gallery.goToMedia) gallery.goToMedia(variant.media_id);

      if(fromUser){
        var url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState(null, '', url);
      }
    }

    radios.forEach(function(r){ r.addEventListener('change', function(){ update(true); }); });
    if(radios.length) update(false);

  }

  /* ---------- product images: hover zoom on desktop, full-screen viewer everywhere ---------- */
  document.querySelectorAll('[data-product-page]').forEach(function(page){
    var scroller = page.querySelector('[data-media-scroller]');
    var lightbox = document.querySelector('[data-lightbox]');
    if(!scroller) return;
    var imgs = scroller.querySelectorAll('img[data-zoomable]');
    var fineHover = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');

    imgs.forEach(function(img){
      img.addEventListener('mousemove', function(e){
        if(!(fineHover && fineHover.matches)) return;
        var r = img.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        img.classList.add('is-hover-zoom');
      });
      img.addEventListener('mouseleave', function(){ img.classList.remove('is-hover-zoom'); img.style.transformOrigin = ''; });
      img.addEventListener('click', function(){ openLightbox(+img.getAttribute('data-index') || 0); });
    });
    var zoomBtn = page.querySelector('[data-zoom-open]');
    if(zoomBtn) zoomBtn.addEventListener('click', function(){
      openLightbox(Math.round(scroller.scrollLeft / Math.max(1, scroller.clientWidth)));
    });

    if(!lightbox) return;
    var track = lightbox.querySelector('[data-lightbox-track]');
    var slides = lightbox.querySelectorAll('[data-lightbox-slide]');
    var counter = lightbox.querySelector('[data-lightbox-count]');
    var prev = lightbox.querySelector('[data-lightbox-prev]');
    var next = lightbox.querySelector('[data-lightbox-next]');

    function index(){ return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function load(i){
      var im = slides[i] && slides[i].querySelector('img[data-src]');
      if(im){ im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); }
    }
    function unzoomAll(){ slides.forEach(function(s){ s.classList.remove('is-zoomed'); }); }
    function show(i, smooth){
      i = Math.max(0, Math.min(slides.length - 1, i));
      load(i); load(i + 1); load(i - 1);
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
      mark(i);
    }
    function mark(i){
      if(counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      if(prev) prev.disabled = i === 0;
      if(next) next.disabled = i === slides.length - 1;
    }
    function openLightbox(i){
      unzoomAll();
      openModal(lightbox, document.activeElement);
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ show(i, false); }); });
    }
    page.openLightbox = openLightbox;

    var ticking = false;
    track.addEventListener('scroll', function(){
      if(ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        ticking = false;
        var i = index();
        load(i); load(i + 1);
        mark(i);
      });
    }, { passive: true });
    if(prev) prev.addEventListener('click', function(){ unzoomAll(); show(index() - 1, true); });
    if(next) next.addEventListener('click', function(){ unzoomAll(); show(index() + 1, true); });

    // click (desktop) or double-tap (phone) toggles a 2.5x zoom you can pan by scrolling/dragging
    function toggleZoom(slide, clientX, clientY){
      var img = slide.querySelector('img');
      if(slide.classList.contains('is-zoomed')){ slide.classList.remove('is-zoomed'); return; }
      var r = img.getBoundingClientRect();
      var fx = r.width ? (clientX - r.left) / r.width : .5;
      var fy = r.height ? (clientY - r.top) / r.height : .5;
      slide.classList.add('is-zoomed');
      requestAnimationFrame(function(){
        slide.scrollLeft = fx * img.offsetWidth - slide.clientWidth / 2;
        slide.scrollTop = fy * img.offsetHeight - slide.clientHeight / 2;
      });
    }
    var lastTap = 0;
    slides.forEach(function(slide){
      slide.addEventListener('click', function(e){
        if(e.target.tagName !== 'IMG') return;
        var coarse = window.matchMedia && matchMedia('(pointer: coarse)').matches;
        if(!coarse){ toggleZoom(slide, e.clientX, e.clientY); return; }
        var now = Date.now();
        if(now - lastTap < 320){ toggleZoom(slide, e.clientX, e.clientY); lastTap = 0; }
        else lastTap = now;
      });
    });

    lightbox.addEventListener('keydown', function(e){
      if(e.key === 'ArrowRight'){ e.preventDefault(); unzoomAll(); show(index() + 1, true); }
      if(e.key === 'ArrowLeft'){ e.preventDefault(); unzoomAll(); show(index() - 1, true); }
    });
  });

  /* ---------- quantity + / − (product page and bag) ---------- */
  var stepTimers = new WeakMap();
  document.addEventListener('click', function(e){
    var btn = closestTo(e, '[data-stepper] [data-step]');
    if(!btn || btn.disabled) return;
    var stepper = btn.closest('[data-stepper]');
    var input = stepper.querySelector('input');
    var min = input.min !== '' ? +input.min : 0;
    var max = input.max !== '' ? +input.max : 999;
    var value = Math.min(max, Math.max(min, (Math.floor(+input.value) || min) + (+btn.getAttribute('data-step'))));
    input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  function syncStepper(stepper){
    var input = stepper.querySelector('input');
    var min = input.min !== '' ? +input.min : 0;
    var max = input.max !== '' ? +input.max : 999;
    var v = Math.floor(+input.value) || min;
    var dec = stepper.querySelector('[data-step="-1"]');
    var inc = stepper.querySelector('[data-step="1"]');
    if(dec) dec.disabled = v <= min;
    if(inc) inc.disabled = v >= max;
  }
  document.querySelectorAll('[data-stepper]').forEach(syncStepper);
  document.addEventListener('input', function(e){
    var stepper = e.target.closest && e.target.closest('[data-stepper]');
    if(!stepper) return;
    syncStepper(stepper);
    // bag: save the new quantity automatically, shortly after the last tap
    if(!stepper.hasAttribute('data-auto-update')) return;
    var form = stepper.closest('form');
    clearTimeout(stepTimers.get(stepper));
    stepTimers.set(stepper, setTimeout(function(){
      if(!(+e.target.value >= 1)) return;
      stepper.classList.add('is-busy');
      var submitter = document.createElement('input');
      submitter.type = 'hidden'; submitter.name = 'update'; submitter.value = '1';
      form.appendChild(submitter);
      form.submit();
    }, 650));
  });

  /* ---------- quick add to bag from product cards (wishlist, recently viewed) ---------- */
  document.addEventListener('submit', function(e){
    var form = e.target.closest && e.target.closest('[data-quick-add]');
    if(!form) return;
    e.preventDefault();
    var select = form.querySelector('select[name="id"]');
    var idField = form.querySelector('[name="id"]');
    if(select && !select.value){
      select.classList.remove('is-invalid');
      void select.offsetWidth;
      select.classList.add('is-invalid');
      select.focus();
      toast('Please choose a size first');
      return;
    }
    if(select) select.classList.remove('is-invalid');
    var btn = form.querySelector('button[type="submit"]');
    var label = btn.querySelector('span');
    var labelText = label ? label.textContent : '';
    btn.disabled = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +idField.value, quantity: 1 }] })
    }).then(function(res){
      return res.json().then(function(json){
        if(!res.ok) throw new Error(json.description || json.message || 'Could not add to bag');
        btn.classList.add('is-added');
        if(label) label.textContent = 'Added';
        toast('Added to bag', 'View bag', root + 'cart');
        refreshCartCount();
        setTimeout(function(){ btn.classList.remove('is-added'); if(label) label.textContent = labelText; btn.disabled = false; }, 1800);
      });
    }).catch(function(err){
      toast(err.message);
      btn.disabled = false;
    });
  });
  document.addEventListener('change', function(e){
    if(e.target.matches && e.target.matches('.card-add__select')) e.target.classList.remove('is-invalid');
  });

  /* ---------- delivery estimate: "Delivered within 3–5 days" ⇄ real dates, rotating ---------- */
  (function(){
    if(!body.hasAttribute('data-eta-min')) return;
    var minDays = +body.getAttribute('data-eta-min') || 3;
    var maxDays = Math.max(minDays, +body.getAttribute('data-eta-max') || 5);
    var skipSunday = body.getAttribute('data-eta-skip-sunday') === 'true';
    var cutoff = +body.getAttribute('data-eta-cutoff') || 0;
    var textRange = body.getAttribute('data-eta-text-range') || 'Delivered within [min]–[max] days';
    var textDates = body.getAttribute('data-eta-text-dates') || 'Get it by [from] – [to]';
    var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    function addDays(start, n){
      var d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
      while(n > 0){
        d.setDate(d.getDate() + 1);
        if(skipSunday && d.getDay() === 0) continue;
        n--;
      }
      return d;
    }
    function fmt(d){ return DAYS[d.getDay()] + ', ' + d.getDate() + ' ' + MONTHS[d.getMonth()]; }
    function messages(){
      // dispatch days and the cut-off hour follow India time, wherever the shopper is
      var now = new Date(Date.now() + (330 + new Date().getTimezoneOffset()) * 60000);
      var start = now;
      if(cutoff && now.getHours() >= cutoff) start = addDays(now, 1);
      var from = addDays(start, minDays);
      var to = addDays(start, maxDays);
      var range = textRange.replace('[min]', minDays).replace('[max]', maxDays);
      if(minDays === maxDays) range = range.replace(minDays + '–' + maxDays, String(minDays));
      var dates = minDays === maxDays
        ? textDates.replace(/\s*[–-]\s*\[to\]/, '').replace('[from]', fmt(from))
        : textDates.replace('[from]', fmt(from)).replace('[to]', fmt(to));
      // product cards are narrow: "Get it by 21 – 23 Sep"
      var sameMonth = from.getMonth() === to.getMonth();
      var short = minDays === maxDays
        ? textDates.replace(/\s*[–-]\s*\[to\]/, '').replace('[from]', from.getDate() + ' ' + MONTHS[from.getMonth()])
        : textDates.replace('[from]', from.getDate() + (sameMonth ? '' : ' ' + MONTHS[from.getMonth()])).replace('[to]', to.getDate() + ' ' + MONTHS[to.getMonth()]);
      return [range, dates, short];
    }

    var index = 0;
    function paint(animate){
      var msgs = messages();
      document.querySelectorAll('[data-eta-text]').forEach(function(el){
        var text = index === 1 && el.closest('.eta--card') ? msgs[2] : msgs[index];
        if(el.textContent === text) return;
        el.textContent = text;
        el.title = msgs[0] + ' · ' + msgs[1];
        if(animate && !reduceMotion){
          el.classList.remove('is-swapping');
          void el.offsetWidth;
          el.classList.add('is-swapping');
        }
      });
      // sticky bar note under "Add to bag" always shows the dates
      document.querySelectorAll('[data-eta-note]').forEach(function(el){ el.textContent = msgs[1]; });
    }
    paint(false);
    setInterval(function(){
      if(document.hidden) return;
      index = (index + 1) % 2;
      paint(true);
    }, 3200);
  })();

  /* ---------- recently viewed ---------- */
  var RV_KEY = 'bh:recently-viewed';
  function rvRead(){
    var list = store(function(){ return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); }, []);
    return Array.isArray(list) ? list.filter(function(h){ return typeof h === 'string' && h; }) : [];
  }
  var viewed = document.querySelector('[data-product-handle]');
  if(viewed){
    var vh = viewed.getAttribute('data-product-handle');
    var rv = rvRead().filter(function(h){ return h !== vh; });
    rv.unshift(vh);
    store(function(){ localStorage.setItem(RV_KEY, JSON.stringify(rv.slice(0, 12))); });
  }
  document.querySelectorAll('[data-recently-viewed]').forEach(function(section){
    var exclude = section.getAttribute('data-exclude');
    var limit = +section.getAttribute('data-limit') || 8;
    var listEl = section.querySelector('[data-recently-viewed-list]');
    var handles = rvRead().filter(function(h){ return h !== exclude; }).slice(0, limit);
    if(!handles.length) return;
    fetchCards(handles).then(function(results){
      var gone = handles.filter(function(_, i){ return results[i] && results[i].gone; });
      if(gone.length) store(function(){ localStorage.setItem(RV_KEY, JSON.stringify(rvRead().filter(function(h){ return gone.indexOf(h) === -1; }))); });
      results.forEach(function(r){ if(r && r.card) listEl.appendChild(r.card); });
      section.hidden = !listEl.children.length;
      if(WL_ON) wlSync();
    });
    var clear = section.querySelector('[data-recently-viewed-clear]');
    if(clear) clear.addEventListener('click', function(){
      store(function(){ localStorage.setItem(RV_KEY, JSON.stringify(exclude ? [exclude] : [])); });
      section.hidden = true;
      listEl.innerHTML = '';
    });
  });

  /* ---------- share product ---------- */
  document.addEventListener('click', function(e){
    var btn = closestTo(e, '[data-share]');
    if(!btn) return;
    var url = btn.getAttribute('data-share-url') || location.href;
    var title = btn.getAttribute('data-share-title') || document.title;
    if(navigator.share){
      navigator.share({ title: title, url: url }).catch(function(){});
    } else if(navigator.clipboard && window.isSecureContext){
      navigator.clipboard.writeText(url).then(function(){ toast('Link copied'); }, function(){ prompt('Copy this link', url); });
    } else {
      prompt('Copy this link', url);
    }
  });

  /* ---------- back to top ---------- */
  var toTop = document.querySelector('[data-to-top]');
  if(toTop){
    var topTicking = false;
    var topShown = false;
    window.addEventListener('scroll', function(){
      if(topTicking) return;
      topTicking = true;
      requestAnimationFrame(function(){
        topTicking = false;
        var show = window.scrollY > window.innerHeight * 1.5;
        if(show === topShown) return;
        topShown = show;
        if(show){ toTop.hidden = false; requestAnimationFrame(function(){ toTop.classList.add('is-visible'); }); }
        else { toTop.classList.remove('is-visible'); setTimeout(function(){ if(!topShown) toTop.hidden = true; }, 200); }
      });
    }, { passive: true });
    toTop.addEventListener('click', function(){
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      var main = document.getElementById('MainContent');
      if(main) main.focus({ preventScroll: true });
    });
  }

  /* ---------- track order: Order ID + mobile → /pages/order-tracking/<id>-<mobile> ---------- */
  var trackForm = document.querySelector('[data-track-form]');
  if(trackForm){
    var trackResult = document.querySelector('[data-track-result]');
    var trackError = trackForm.querySelector('[data-track-error]');
    var trackBtn = trackForm.querySelector('[data-track-submit]');
    var orderInput = trackForm.querySelector('[name="order"]');
    var phoneInput = trackForm.querySelector('[name="phone"]');
    var notFound = document.querySelector('[data-track-not-found]');
    var trackWa = document.querySelector('[data-track-wa]');

    function fail(input, message){
      trackError.textContent = message;
      trackError.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      input.focus();
    }
    [orderInput, phoneInput].forEach(function(input){
      input.addEventListener('input', function(){ input.removeAttribute('aria-invalid'); trackError.hidden = true; });
    });

    // prefill from ?order=…&phone=… (e.g. links in WhatsApp messages)
    var qs = new URLSearchParams(location.search);
    if(qs.get('order')) orderInput.value = qs.get('order');
    if(qs.get('phone')) phoneInput.value = qs.get('phone');

    trackForm.addEventListener('submit', function(e){
      e.preventDefault();
      trackError.hidden = true;
      var order = orderInput.value.toUpperCase().replace(/^#/, '').replace(/[^A-Z0-9-]/g, '');
      var phone = phoneInput.value.replace(/\D/g, '');
      if(phone.length > 10) phone = phone.slice(-10);
      if(order.length < 3) return fail(orderInput, 'Please enter your Order ID, e.g. ' + orderInput.placeholder.replace(/^e\.g\.\s*/, ''));
      if(phone.length !== 10) return fail(phoneInput, 'Please enter the 10-digit mobile number used for the order.');

      var handle = (order + '-' + phone).toLowerCase();
      trackBtn.disabled = true;
      trackBtn.textContent = 'Checking…';
      if(trackWa) trackWa.href = trackWa.href.split('?')[0] + '?text=' + encodeURIComponent('Hi, I need an update on my order ' + order);

      fetch(root + 'pages/order-tracking/' + encodeURIComponent(handle), { headers: { 'Accept': 'text/html' } })
        .then(function(res){
          if(!res.ok) return null;
          return res.text().then(function(html){
            var tpl = document.createElement('template');
            tpl.innerHTML = html;
            return tpl.content.querySelector('[data-track-card]');
          });
        })
        .catch(function(){ return null; })
        .then(function(card){
          trackResult.innerHTML = '';
          if(card){
            trackResult.appendChild(card);
          } else if(notFound){
            trackResult.appendChild(notFound.content.cloneNode(true));
          }
          trackResult.hidden = false;
          trackBtn.disabled = false;
          trackBtn.textContent = 'Track order';
          trackResult.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        });
    });
  }

  /* ---------- top strip: rotate messages (only visible as a rotation on phones) ---------- */
  var offers = document.querySelector('.topbar-offers');
  if(offers){
    var offerItems = offers.querySelectorAll('span');
    if(offerItems.length > 1){
      var offerIndex = 0;
      offers.classList.add('is-rotating');
      offerItems[0].classList.add('is-active');
      setInterval(function(){
        offerItems[offerIndex].classList.remove('is-active');
        offerIndex = (offerIndex + 1) % offerItems.length;
        offerItems[offerIndex].classList.add('is-active');
      }, 3500);
    }
  }

  /* ---------- modals: menu drawer, product details / size chart sheets ---------- */
  var openModals = [];
  var modalOpeners = new WeakMap();

  function focusables(el){
    return Array.prototype.filter.call(
      el.querySelectorAll('a[href],button:not([disabled]),input:not([type="hidden"]):not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])'),
      function(n){ return n.offsetParent !== null; }
    );
  }

  function openModal(modal, opener){
    // check the open list, not [hidden]: a modal that is still fading out can be reopened straight away
    if(!modal || openModals.indexOf(modal) > -1) return;
    modalOpeners.set(modal, opener || document.activeElement);
    modal.hidden = false;
    openModals.push(modal);
    document.documentElement.classList.add('scroll-lock');
    document.querySelectorAll('[data-modal-open="' + modal.id + '"]').forEach(function(b){ b.setAttribute('aria-expanded', 'true'); });
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        modal.classList.add('is-open');
        var panel = modal.querySelector('[role="dialog"]');
        if(panel) panel.focus({ preventScroll: true });
      });
    });
    modal.dispatchEvent(new CustomEvent('modal:open', { bubbles: true }));
  }

  function closeModal(modal){
    if(!modal || openModals.indexOf(modal) === -1) return;
    modal.classList.remove('is-open');
    openModals = openModals.filter(function(m){ return m !== modal; });
    if(!openModals.length) document.documentElement.classList.remove('scroll-lock');
    document.querySelectorAll('[data-modal-open="' + modal.id + '"]').forEach(function(b){ b.setAttribute('aria-expanded', 'false'); });
    var panel = modal.querySelector('.sheet-panel');
    if(panel){ panel.style.transform = ''; }
    setTimeout(function(){ if(!modal.classList.contains('is-open')) modal.hidden = true; }, reduceMotion ? 0 : 320);
    var opener = modalOpeners.get(modal);
    if(opener && opener.focus && document.contains(opener)) opener.focus({ preventScroll: true });
  }

  document.addEventListener('click', function(e){
    var opener = closestTo(e, '[data-modal-open]');
    if(opener){
      e.preventDefault();
      openModal(document.getElementById(opener.getAttribute('data-modal-open')), opener);
      return;
    }
    var closer = closestTo(e, '[data-modal-close]');
    if(closer){ closeModal(closer.closest('[data-modal]')); }
  });

  document.addEventListener('keydown', function(e){
    var top = openModals[openModals.length - 1];
    if(!top) return;
    if(e.key === 'Escape'){ e.preventDefault(); closeModal(top); return; }
    if(e.key === 'Tab'){
      var list = focusables(top);
      if(!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if(e.shiftKey && (document.activeElement === first || !top.contains(document.activeElement))){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    }
  });

  // phones: drag a bottom sheet down by its handle/header to close it
  document.querySelectorAll('.sheet').forEach(function(sheet){
    var panel = sheet.querySelector('.sheet-panel');
    var grab = sheet.querySelectorAll('.sheet-handle, .sheet-head');
    var startY = null, dy = 0;
    function isPhone(){ return window.innerWidth < 750; }
    grab.forEach(function(el){
      el.addEventListener('touchstart', function(e){
        if(!isPhone() || closestTo(e, 'button')) return;
        startY = e.touches[0].clientY; dy = 0;
        panel.classList.add('is-dragging');
      }, { passive: true });
    });
    panel.addEventListener('touchmove', function(e){
      if(startY === null) return;
      dy = Math.max(0, e.touches[0].clientY - startY);
      panel.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    panel.addEventListener('touchend', function(){
      if(startY === null) return;
      panel.classList.remove('is-dragging');
      startY = null;
      if(dy > 90){ closeModal(sheet); } else { panel.style.transform = ''; }
    });
  });

  /* ---------- size chart from product cards (content fetched from the page) ---------- */
  var sizeChartSheet = document.getElementById('SizeChartSheet');
  var sizeChartCache = {};
  document.addEventListener('click', function(e){
    var btn = closestTo(e, '[data-size-chart-url]');
    if(!btn || !sizeChartSheet) return;
    e.preventDefault();
    var url = btn.getAttribute('data-size-chart-url');
    var title = btn.getAttribute('data-size-chart-title') || 'Size chart';
    var bodyEl = sizeChartSheet.querySelector('[data-size-chart-body]');
    sizeChartSheet.querySelector('.sheet-title').textContent = title;
    openModal(sizeChartSheet, btn);
    if(sizeChartCache[url]){ bodyEl.innerHTML = sizeChartCache[url]; return; }
    bodyEl.innerHTML = '<p class="sheet-loading">Loading size chart…</p>';
    fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'view=sheet', { headers: { 'Accept': 'text/html' } })
      .then(function(res){ if(!res.ok) throw new Error(res.status); return res.text(); })
      .then(function(html){
        var tpl = document.createElement('template');
        tpl.innerHTML = html;
        var content = tpl.content.querySelector('[data-sheet-content]');
        if(!content) throw new Error('no content');
        sizeChartCache[url] = content.innerHTML;
        bodyEl.innerHTML = content.innerHTML;
      })
      .catch(function(){
        bodyEl.innerHTML = '';
        var p = document.createElement('p');
        var a = document.createElement('a');
        a.href = url; a.textContent = 'Open the size chart page';
        p.appendChild(document.createTextNode('Could not load the size chart here. '));
        p.appendChild(a);
        bodyEl.appendChild(p);
      });
  });

  /* ---------- accordions: drawer menu + footer columns on phones ---------- */
  document.addEventListener('click', function(e){
    var toggle = closestTo(e, '.drawer .acc-toggle, .site-footer .acc-toggle');
    if(!toggle) return;
    var item = toggle.closest('.acc');
    var open = !item.classList.contains('is-open');
    item.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
  });

  /* ---------- collections menu: every collection, loaded once from /collections?view=menu ---------- */
  var collectionsPromise = null;
  var MENU_CACHE = 'bh:menu-collections:v2';
  var MENU_TTL = 10 * 60 * 1000;
  function loadCollections(){
    var slots = document.querySelectorAll('[data-collections-slot]');
    if(!slots.length) return null;
    if(collectionsPromise) return collectionsPromise;
    var cached = store(function(){ return JSON.parse(sessionStorage.getItem(MENU_CACHE)); }, null);
    var source = (cached && cached.html && Date.now() - cached.t < MENU_TTL)
      ? Promise.resolve(cached.html)
      : fetch(root + 'collections?view=menu', { headers: { 'Accept': 'text/html' } })
          .then(function(res){ if(!res.ok) throw new Error('menu ' + res.status); return res.text(); })
          .then(function(html){
            store(function(){ sessionStorage.setItem(MENU_CACHE, JSON.stringify({ t: Date.now(), html: html })); });
            return html;
          });
    collectionsPromise = source.then(function(html){
      var tpl = document.createElement('template');
      tpl.innerHTML = html;
      var fragment = tpl.content.querySelector('[data-menu-collections]');
      if(!fragment) throw new Error('menu fragment missing');
      slots.forEach(function(slot){
        slot.innerHTML = '';
        slot.appendChild(fragment.cloneNode(true));
        slot.querySelectorAll('a[href]').forEach(function(a){
          if(a.pathname !== location.pathname) return;
          a.setAttribute('aria-current', 'page');
          var group = a.closest('.acc');
          if(group && slot.closest('[data-menu-drawer]')){
            group.classList.add('is-open');
            var t = group.querySelector('.acc-toggle');
            if(t) t.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }).catch(function(){
      collectionsPromise = null;
      store(function(){ sessionStorage.removeItem(MENU_CACHE); });
      document.querySelectorAll('[data-collections-slot] .menu-loading').forEach(function(el){ el.hidden = true; });
    });
    return collectionsPromise;
  }

  // drawer tabs: Menu / All collections
  document.addEventListener('click', function(e){
    var tab = closestTo(e, '[data-drawer-tab]');
    if(!tab) return;
    var tabs = tab.parentNode.querySelectorAll('[data-drawer-tab]');
    tabs.forEach(function(t){
      var on = t === tab;
      t.setAttribute('aria-selected', String(on));
      var pane = document.getElementById(t.getAttribute('aria-controls'));
      if(pane) pane.hidden = !on;
    });
    if(tab.getAttribute('aria-controls') === 'DrawerCollections') loadCollections();
  });

  var menuDrawer = document.querySelector('[data-menu-drawer]');
  if(menuDrawer){
    menuDrawer.addEventListener('modal:open', function(){ loadCollections(); });
    document.querySelectorAll('[data-modal-open="' + menuDrawer.id + '"]').forEach(function(b){
      b.addEventListener('pointerdown', loadCollections, { passive: true, once: true });
    });
  }

  /* ---------- desktop dropdowns + collections mega menu ---------- */
  var dropdownItems = document.querySelectorAll('[data-dropdown]');
  var hoverQuery = window.matchMedia ? matchMedia('(hover: hover) and (min-width: 1200px)') : null;

  function setDropdown(item, open){
    var btn = item.querySelector('.nav-link');
    if(!btn) return;
    btn.setAttribute('aria-expanded', String(open));
    if(open && item.hasAttribute('data-mega')) loadCollections();
  }
  function closeDropdowns(except){
    dropdownItems.forEach(function(item){ if(item !== except) setDropdown(item, false); });
  }

  dropdownItems.forEach(function(item){
    var btn = item.querySelector('.nav-link');
    var timer;
    btn.addEventListener('click', function(){
      var canHover = hoverQuery && hoverQuery.matches;
      var open = btn.getAttribute('aria-expanded') !== 'true' || (canHover && item.matches(':hover'));
      clearTimeout(timer);
      closeDropdowns(item);
      setDropdown(item, open);
    });
    item.addEventListener('mouseenter', function(){
      if(!(hoverQuery && hoverQuery.matches)) return;
      clearTimeout(timer);
      timer = setTimeout(function(){ closeDropdowns(item); setDropdown(item, true); }, 90);
    });
    item.addEventListener('mouseleave', function(){
      if(!(hoverQuery && hoverQuery.matches)) return;
      clearTimeout(timer);
      timer = setTimeout(function(){ setDropdown(item, false); }, 200);
    });
    item.addEventListener('focusout', function(e){
      if(!item.contains(e.relatedTarget)) setDropdown(item, false);
    });
    item.addEventListener('keydown', function(e){
      if(e.key !== 'Escape' || btn.getAttribute('aria-expanded') !== 'true') return;
      e.stopPropagation();
      setDropdown(item, false);
      btn.focus();
    });
  });

  document.addEventListener('click', function(e){
    if(!closestTo(e, '[data-dropdown]')) closeDropdowns(null);
  });

  window.addEventListener('resize', function(){
    if(window.innerWidth >= 1200 && menuDrawer) closeModal(menuDrawer);
    if(window.innerWidth < 1200) closeDropdowns(null);
  });

  // desktop: fetch the collections menu in the background so it opens instantly
  if(dropdownItems.length && window.innerWidth >= 1200){
    (window.requestIdleCallback || function(fn){ return setTimeout(fn, 1500); })(function(){ loadCollections(); });
  }

  /* ---------- recent searches ---------- */
  var searchForm = document.querySelector('[data-search-form]');
  if(searchForm){
    var KEY = 'bh:recent-searches';
    var readRecent = function(){ return store(function(){ return JSON.parse(localStorage.getItem(KEY) || '[]'); }, []); };
    searchForm.addEventListener('submit', function(){
      var q = searchForm.querySelector('input[name="q"]').value.trim();
      if(!q) return;
      var list = readRecent().filter(function(x){ return x !== q; });
      list.unshift(q);
      store(function(){ localStorage.setItem(KEY, JSON.stringify(list.slice(0,6))); });
    });
    var host = document.querySelector('[data-recent-searches]');
    if(host){
      var recent = readRecent();
      recent.forEach(function(q){
        var a = document.createElement('a');
        a.className = 'chip';
        a.href = root + 'search?type=product&filter.v.availability=1&q=' + encodeURIComponent(q);
        a.textContent = q;
        host.appendChild(a);
      });
      host.hidden = !recent.length;
    }
  }

  /* ---------- facet form auto-submit ---------- */
  var facets = document.querySelector('[data-facet-form]');
  if(facets){
    facets.addEventListener('change', function(){ facets.submit(); });
  }
})();
